import { assertNever, toNumber, } from '@freelancer/datastore/core';
import { OnlineOfflineUserStatusValueApi } from './online-offline.backend';
export function transformOnlineOfflineStatusType(status) {
    switch (status) {
        case OnlineOfflineUserStatusValueApi.ONLINE:
            return "online" /* ONLINE */;
        case OnlineOfflineUserStatusValueApi.OFFLINE:
            return "offline" /* OFFLINE */;
        default:
            return assertNever(status);
    }
}
export function transformOnlineOfflineStatusFetch(_a) {
    var userId = _a[0], status = _a[1];
    return {
        id: toNumber(userId),
        status: transformOnlineOfflineStatusType(status),
    };
}
export function transformOnlineOfflineStatusChange(data) {
    return {
        id: data.user,
        status: transformOnlineOfflineStatusType(data.to),
    };
}
